const Pages = {
  Accounts: 'accounts',
  AddAccount: 'add-account',
  Orders: 'orders',
  GoldHistory: 'gold-history',
  FAQ: 'faq',
  News: 'news',
  Redeem: 'redeem',
  Settings: 'settings'
}

const Navigation = {
  state: {
    Pages,
    currentPage: Pages.Redeem,
    currentPageDepth: 0,
    addAccountDialogVisible: false,
    appLoading: true,
  },
  getters: {
    currentPage: state => state.currentPage,
    currentPageDepth: state => state.currentPageDepth,
    Pages: state => state.Pages,
    appLoading: state => state.appLoading,
  },
  mutations: {
    setCurrentPage: (state, page) => state.currentPage = page,
    pushCurrentPageDepth: (state) => state.currentPageDepth++,
    popCurrentPageDepth: (state) => state.currentPageDepth > 0 ? --state.currentPageDepth : state.currentPageDepth,
    setAppLoading: (state) => state.appLoading = true,
    unsetAppLoading: (state) => state.appLoading = false,
  },
  actions: {
    changePage: ({ commit }, page) => commit('setCurrentPage', page),
    pushPageDepth: ({ commit }) => commit('pushCurrentPageDepth'),
    popPageDepth: ({ commit }) => commit('popCurrentPageDepth'),
    setAppLoading: ({ commit }) => commit('setAppLoading'),
    unsetAppLoading: ({ commit }) => commit('unsetAppLoading'),
  },
}

export {
  Navigation
}